<template>
  <!-- 自定义表格区域 -->
  <Dropdown :transfer='true' class="customerTableColumn themeable" style="margin-left: 20px; float: right;" trigger="click">
    <Button type="dashed">
      + 自定义显示项
      <!-- <Icon type="arrow-down-b"></Icon> -->
    </Button>
    <DropdownMenu style="" slot="list">
      <DropdownItem v-for="(item, index) in columnTotal" :key="index">
        <Checkbox @click.native.stop="chooseTitle(item,$event)" :disabled="item.disable" :data-title="item.title"
          :value="!!column.find(i => i.title == item.title)">
          <!-- <label style="display: inline-block; height: 100%; width: 100%;">{{ item.title }}</label> -->
          {{ item.title }}
        </Checkbox>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
  import {
    app
  } from '@/base/config.js'
  export default {
    props: ['columnTotal', 'column','sourceType'],
    data() {
      return {

      }
    },
    watch: {
      columnTotal(vue) {
        this.orderList();
      }
    },
    created() {
      this.orderList();
    },
    methods: {
      orderList() {
        this.columnTotal.forEach((e, i) => {
          e.index = i;
        })
        this.column.forEach(i => {
          var item = this.columnTotal.find(it => it.title == i.title);
          if (item) {
            i.index = item.index;
          }
        });
      },
      // 选择表格自定义列
      chooseTitle(item, event) {
        // 如果是必选
        if (item.disable) return;
        if (event.target.checked == undefined) return;
        var currentItem = this.column.find(i => i.title == item.title);
        var hasAction = this.column.find(i => i.title == '操作');
        if (!event.target.checked) {
          this.column.splice(this.column.indexOf(currentItem), 1)
        } else {
          if (hasAction) {
            this.column.splice(this.column.length - 1, 1, item)
            this.column.sort((a, b) => a.index - b.index)
            this.column.push(hasAction)
          } else {
            this.column.push(item)
            this.column.sort((a, b) => a.index - b.index)
          }
        }
        if(this.sourceType)  app.cookieUtil._setCookie(this.sourceType,JSON.stringify(this.column.map(x=>x.key)),100);
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/common/tableColumn.vue